import {useState} from 'react';
import PropTypes from 'prop-types';
import './ResetAttributeButton.scss';
import {Refresh} from '@mui/icons-material';
import SigIconButton from 'components/SigIconButton/SigIconButton';
import {Button, CircularProgress} from '@mui/material';
import {grey} from '@mui/material/colors';

const ResetAttributeButton = ({ buttonRef, disabled, isLoading, title, variant, onReset }) => {
  const [isContained] = useState(variant === 'contained');
  const renderLoader = (size = 24) => (
    <CircularProgress classes={{root: 'loader'}} variant="indeterminate" size={size} />
  );

  function onResetClick(event) {
    onReset && onReset();
    event.stopPropagation();
  }

  function renderIcon() {
    if (isLoading) {
      return renderLoader();
    }
    return (
      <SigIconButton
        title={title}
        buttonProps={{
          'aria-label': 'Reset',
          disabled,
          edge: 'end',
          size: 'small',
          ref: buttonRef,
          onClick: onResetClick,
        }}
        icon={<Refresh />}
      />
    );
  }

  function renderContained() {
    return (
      <Button
        variant="contained"
        aria-label="Reset"
        startIcon={
          isLoading ? null : <Refresh />
        }
        disabled={disabled || isLoading}
        onClick={onResetClick}
        sx={(theme) => ({ mr:  1, backgroundColor: grey[300], color: theme.palette.text.secondary })}
      >
        {isLoading ? renderLoader() : 'Refresh'}
      </Button>
    );
  }

  return (
    <div className={`ResetAttributeButton ${variant}`} data-testid="ResetAttributeButton">
      {isContained ? renderContained() : renderIcon()}
    </div>
  );
};

ResetAttributeButton.propTypes = {
  buttonRef: PropTypes.any,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  title: PropTypes.string,
  variant: PropTypes.oneOf(['icon', 'contained']),
  onReset: PropTypes.func.isRequired,
};

ResetAttributeButton.defaultProps = {
  disabled: false,
  title: 'Click to reset the price value',
  variant: 'icon',
};

export default ResetAttributeButton;
